module.exports = __webpack_public_path__ + "img/elnoki.5768c422.jpg";